import React, { useState } from 'react';

import { Button, Form, Input, Select, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

type Props = {
  onDone: (token: string) => void,
  currentValues: Object,
  submitData: (data: Object) => void,
};

/*
This form for information:
        email
        owner_id
        mileage
        id_type
* */

const LeadPageOwnerMileageForm = ({
  onDone,
  currentValues = {},
  submitData,
}: Props) => {
  const [busy, setBusy] = useState(false);
  const [form] = Form.useForm();

  const onFinish = (values) => {
    setBusy(true);
    submitData(values)
      .then(function (res) {
        if (res.data.result === 'Success') {
          onDone(res.data.token, values);
        }
      })
      .finally(() => setBusy(false));
  };

  return (
    <Form
      className="lead-page-form opacity-95 lg:opacity-100 transition-opacity"
      onFinish={onFinish}
      initialValues={{
        // email: 'charlie.tan@thecarousell.com',
        // owner_id: '111B',
        // mileage: '20000',
        id_type: 'Singapore NRIC',
      }}
      form={form}
    >
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        spinning={busy}
      >
        <h3 className="text-center mb-0 font-semibold">
          {currentValues.vehicle_no}
        </h3>
        <h4 className="text-center mt-0 mb-6">
          <span className="sq-owner-name">{currentValues.owner_name}</span>
          <span className="ml-1 mr-1">|</span>
          <span className="sq-mobile-no">{currentValues.mobile_no}</span>
        </h4>
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: 'This field is required.',
            },
            {
              type: 'email',
              message: 'Please enter a valid email address.',
            },
          ]}
        >
          <Input type="email" placeholder="Enter your email" size="large" />
        </Form.Item>
        <Form.Item name="id_type">
          <Select size="large">
            <Select.Option value="Business">
              Business (e.g. 51234567M)
            </Select.Option>
            <Select.Option value="Club/Association/Organisation">
              Club/Association/Organisation (e.g. T08PQ1234A)
            </Select.Option>
            <Select.Option value="Company">
              Company (e.g. 198912345K)
            </Select.Option>
            <Select.Option value="Foreign Company">
              Foreign Company (e.g. T08FC1234A)
            </Select.Option>
            <Select.Option value="Foreign Identification Number">
              Foreign Identification Number (e.g. F/G1234567N)
            </Select.Option>
            <Select.Option value="Foreign Passport">
              Foreign Passport (e.g. 12345678)
            </Select.Option>
            <Select.Option value="Government">
              Government (e.g. T08GA1234A)
            </Select.Option>
            <Select.Option value="Limited Liability Partnership">
              Limited Liability Partnership (e.g. T08LL1234A)
            </Select.Option>
            <Select.Option value="Limited Partnership">
              Limited Partnership (e.g. T08LP1234A)
            </Select.Option>
            <Select.Option value="Malaysia NRIC">
              Malaysia NRIC (e.g. 200312345678)
            </Select.Option>
            <Select.Option value="Professional">
              Professional (e.g. T08PQ1234A)
            </Select.Option>
            <Select.Option value="Singapore NRIC">
              Singapore NRIC (e.g. S1234567D)
            </Select.Option>
            <Select.Option value="Statutory Board">
              Statutory Board (e.g. T08GB1234A)
            </Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="owner_id"
          rules={[
            {
              required: true,
              message: 'This field is required.',
            },
          ]}
        >
          <Input
            type="text"
            placeholder="Enter owner id, eg. 063F"
            size="large"
          />
        </Form.Item>
        <Form.Item name="mileage">
          <Input type="text" placeholder="Mileage" size="large" />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="get-quote-button"
            size="large"
          >
            Next
          </Button>
        </Form.Item>
      </Spin>
    </Form>
  );
};

export default LeadPageOwnerMileageForm;
